// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_29zUjKb1jIc1","right":"_2M7rg3aDJZV1"};